import { render, staticRenderFns } from "./module2Details.vue?vue&type=template&id=05070318&"
import script from "./module2Details.vue?vue&type=script&lang=js&"
export * from "./module2Details.vue?vue&type=script&lang=js&"
import style0 from "./module2Details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports